import { ISpinnerState } from './spinner-state.interface';
import { DictionaryType } from './dictionary-type.model';

export class SpinnerState implements ISpinnerState {
  shown = false;
  messages = new DictionaryType<string>();
}
